<template>
  <div id="wrapper">
    <router-view/>
    <common-loading></common-loading>
  </div>
</template>

<script>
export default {
  name: 'NoInfoHeaderLayout'
}
</script>

